import SalesTax from "sales-tax";
import { lazy } from "../utils/lazy";

export class SalesTaxService {
  salesTax: typeof SalesTax;

  constructor() {
    this.salesTax = SalesTax;
    this.salesTax.setTaxOriginCountry("PL");
  }

  async getSalesTax(country: string, companyId?: string) {
    if (country === "PL") {
      return {
        "type": "vat",
        "rate": 0.23,
        "area": "national",
        "exchange": "consumer",
        "charge": {
            "direct": true,
            "reverse": false
        },
        "details": [
            {
                "type": "vat",
                "rate": 0.23
            }
        ]
      };
    }
    return this.salesTax.getSalesTax(country, undefined, companyId);
  }

  async validateTaxNumber(country: string, companyId: string) {
    if (country === "PL") {
      return true;
    }
    return this.salesTax.validateTaxNumber(country, companyId);
  }
}

export const salesTaxService = lazy(() => new SalesTaxService());
